import React from 'react';
import {
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography,
} from "@mui/material";
import { AddRounded, CloseRounded } from "@mui/icons-material";

const _GroupAddModal = ({ open, onClose, onSubmit, submitting, groupName, setGroupName }) => {
    return (
        <Dialog
            open={open}
            onClose={() => !submitting && onClose()}
            maxWidth="xs"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                    p: 1,
                    boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                }
            }}
        >
            <Box component="form" onSubmit={onSubmit}>
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: 2.5,
                                bgcolor: 'rgba(28, 139, 156, 0.1)',
                                color: 'primary.main',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <AddRounded />
                        </Box>
                        <Typography variant="h6" sx={{ fontWeight: 800 }}>
                            افزودن گروه یا تگ سازمانی
                        </Typography>
                    </Box>
                    <IconButton
                        size="small"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ color: 'text.secondary' }}
                    >
                        <CloseRounded fontSize="small" />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 2.5 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                        نام گروه را جهت دسته‌بندی و تعیین اعتبار پرسنل وارد کنید:
                    </Typography>
                    <TextField
                        autoFocus
                        name="Name"
                        label="نام گروه سازمانی"
                        placeholder="مثال: تیم فنی، مدیران، پرسنل شیفت..."
                        type="text"
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        fullWidth
                        required
                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2.5 } }}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1 }}>
                    <Button
                        variant="text"
                        onClick={onClose}
                        disabled={submitting}
                        sx={{ borderRadius: 2.5, px: 2, color: 'text.secondary' }}
                    >
                        انصراف
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={submitting || !groupName.trim()}
                        sx={{
                            borderRadius: 2.5,
                            px: 3,
                            fontWeight: 700,
                            boxShadow: '0 4px 14px rgba(28, 139, 156, 0.25)'
                        }}
                    >
                        {submitting ? <CircularProgress size={20} color="inherit" /> : "افزودن گروه"}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
};

export default _GroupAddModal;
